/**
 * 路由守卫(路由权限控制)
 */
import Router from '@/router';                                  //  路由管理
import Store from '@/store';                                    //  状态管理
import Storage from 'store2';                                   //  本地存储
import { Message } from 'element-ui';                           //  消息提示
import NProgress from 'nprogress';                              //  progress bar
import 'nprogress/nprogress.css';                               //  progress bar css
import { setDocumentTitle, domTitle } from '@/utils/domUtil';   //  设置页面信息
import { i18nRender } from '@/locales';                         //  国际化
import user from '@/utils/user.js';                             //  用户操作类库
import util from "@/utils/util.js";                             //	工具函数库

//  获得，登录状态下不能访问的列表；未登录状态不能访问的列表
import { loginRefuseList, loginAllowList } from '@/config/router.config';

const loginRoutePath = '/auth/login'                            //  登录路由地址
const defaultRoutePath = '/'                                    //  默认路由地址

//  路由前卫
Router.beforeEach((to, from, next) => {
  NProgress.start();
  let documentTitle = '';
  //  如果是首页就把首页标题给去掉，只显示米其林集采平台
  if(to.name=='index'){
    documentTitle = `${domTitle}`;
  }else{
    documentTitle = `${i18nRender(to.meta.title)} - ${domTitle}`;
  }
  to.meta && typeof to.meta.title !== 'undefined' && setDocumentTitle(documentTitle);
  console.log('to', to)
  //  访问统计收集
  util.visitor({
    from: {
      fullPath: from.fullPath,
      path: from.path,
      meta: from.meta,
      name: from.name,
      query: from.query
    },
    to: {
      fullPath: to.fullPath,
      path: to.path,
      meta: to.meta,
      name: to.name,
      query: to.query
    }
  });

  //  验证用是否登录
  if (user.checkLogin()) {
    //  登录状态下不能访问的列表，如果访问的界面是用户登录后不能访问的界面，那么就跳转到首页
    if (loginRefuseList.includes(to.name)) {
      next({ path: defaultRoutePath });
      NProgress.done();
    } else {
      next();
    }
  } else {
    //  未登录状态不能访问的列表，如果访问的界面是需要用户登录后才能访问的界面，那么就跳转到登录界面
    if (loginAllowList.includes(to.name)) {
      next({ path: loginRoutePath });
      NProgress.done();
    } else {
      next();
    }
  }
});

//  路由后卫
Router.afterEach(() => {
  NProgress.done();
});
